import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { STYLES } from "./ShoppingCartStyles";
import { SxProps, Theme } from "@mui/material";

interface SummaryRowProps {
  label: string;
  value: string;
  labelStyle?: SxProps<Theme>;
  valueStyle?: SxProps<Theme>;
}

export const SummaryRow: React.FC<SummaryRowProps> = ({
  label,
  value,
  labelStyle,
  valueStyle,
}) => (
  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
    <Typography
      sx={{
        fontFamily: STYLES.fontFamily,
        fontSize: "14px",
        color: STYLES.colors.primary,
        ...labelStyle,
      }}
    >
      {label}
    </Typography>
    <Typography
      sx={{
        fontFamily: STYLES.fontFamily,
        fontSize: "14px",
        color: STYLES.colors.primary,
        ...valueStyle,
      }}
    >
      {value}
    </Typography>
  </Box>
);














